// keep your imports as they are
import React, { useState, useContext, useEffect } from "react";
import "./Styles/sidebar.css";
import axios from "axios";
import { SidebarData } from "./SidebarData";
import { NavLink } from "react-router-dom";
import logo from "../Assets/Images/logo2.png";
import { AuthLoginInfo } from "./../AuthComponents/AuthLogin";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import configData from "../Pages/config.json";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SocketDataContext } from "../App"; // or from separate provider file

const customId = "toast-main";

// logout stays as a module-level helper (no socket needed)
const logout = () => {
  axios
    .get(configData.BACKEND_URL + "/logout", {
      withCredentials: true,
    })
    .then((res) => {
      if (res.data === "success") {
        window.location.href = "/login";
      }
    });
};

const NavbarSection = ({
  ctx,
  sidebarCollapse,
  handleOnClick,
  terminateAll,
  terminateSquareOffAll,
  ltpData,
  livePnl,
  totalPnl,  
}) => {
  const HamburgerMenu = ({ handleOnClick }) => {
    return (
      <button
        className={`hamburgerMenu ${
          sidebarCollapse ? "hamburgerMenuOpen" : "hamburgerMenuClosed"
        }`}
        onClick={() => handleOnClick()}
      >
        <div />
        <div />
        <div />
      </button>
    );
  };

  return (
    <div className="navbar">
      <div className="navbarWrap">
        <div className="navbarRow">
          <HamburgerMenu handleOnClick={handleOnClick} />
          <div className="globalltp">
            {ltpData &&
              Object.keys(ltpData).map((key) => (
                <span key={key}>
                  <strong>{key}:</strong>{" "}
                  <span className="greenbold">
                    {JSON.stringify(ltpData[key])}
                  </span>{" "}
                </span>
              ))}
            {/* show live / total pnl */}
            {livePnl > 0 && (
              <span>
                {" "}
                <strong>LIVE PNL:</strong>{" "}
                <span className="greenbold">{livePnl}</span>{" "}
              </span>
            )}
            {livePnl < 0 && (
              <span>
                {" "}
                <strong>LIVE PNL:</strong>{" "}
                <span className="redbold">{livePnl}</span>{" "}
              </span>
            )}
            {totalPnl > 0 && (
              <span>
                {" "}
                <strong>TOTAL PNL:</strong>{" "}
                <span className="greenbold">{totalPnl}</span>{" "}
              </span>
            )}
            {totalPnl < 0 && (
              <span>
                {" "}
                <strong>TOTAL PNL:</strong>{" "}
                <span className="redbold">{totalPnl}</span>{" "}
              </span>
            )}
          </div>

        </div>

        <div className="navbarRowLast">
          {ctx && (
            <div className="userNavbar ">
              <div className="globalltp"></div>
              <div>
                <button
                  title="Terminate All"
                  className="terminateWithoutSquareOffButton"
                  onClick={terminateAll}
                >
                  <PowerSettingsNewIcon />
                </button>
                <button
                  title="Squareoff and Terminate All"
                  className="terminateSquareOffButton"
                  onClick={terminateSquareOffAll}
                >
                  <PowerSettingsNewIcon />
                </button>
              </div>
              <div className="userLogo">
                <AccountCircleRoundedIcon />
              </div>
              <div className="userLogged">Logged as: {ctx.username}</div>
              <div
                className="navbarFlex"
                onClick={() => {
                  logout();
                }}
              >
                <div className="userLogo">
                  <LogoutRoundedIcon className="maincolor clickable" />
                </div>
                <div className="logout clickable">Logout</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const SidebarSection = ({ ctx, globalLTP, sidebarCollapse }) => {
  return (
    <div
      className={`Sidebar ${sidebarCollapse ? "SidebarOpen" : "SidebarClosed"}`}
    >
      <div className="SidebarLogoWrap">
        <div className="SidebarLogo">
          <img src={logo} className="logo" alt="" />
        </div>
      </div>

      <ul className="SidebarList">
        {SidebarData.map((val, key) => {
          if (val?.role !== undefined && val?.role !== ctx?.role) {
            return null;
          }
          return (
            <NavLink
              to={val.link}
              key={key}
              className={({ isActive }) =>
                isActive ? "sidebar-active-link" : "sidebar-link"
              }
            >
              <li className="SidebarRow">
                <div className="RowIcon">{val.icon}</div>
              </li>
            </NavLink>
          );
        })}
      </ul>
    </div>
  );
};

function Sidebar() {
  const ctx = useContext(AuthLoginInfo);
  const toastId = React.useRef(null);
  const { socket, ltpData, livePnl, totalPnl } = useContext(SocketDataContext);
  const [sidebarCollapse, setSidebarCollapse] = useState(true);
  const handleSidebarCollapse = () => {
    setSidebarCollapse((prev) => !prev);
  };

  const notify = (toast_mess, ntype, position, autoclose) => {
    //if(! toast.isActive(toastId.current)) {
      var auto_close = false;
      if(autoclose === true) auto_close = 2000; else auto_close = false;
      if(ntype === 'success') {
        toastId.current = toast.success(toast_mess, {
          position: position,
          theme: "dark",
          toastId: customId,
          autoClose : auto_close,
          newestOnTop: true
        });
      } else if (ntype === 'error') {
        toastId.current = toast.error(toast_mess, {
          position: position,
          theme: "dark",
          toastId: customId,
          autoClose : auto_close,
          newestOnTop: true
        });        
      } else {
        toastId.current = toast.success(toast_mess, {
          position: position,
          theme: "dark",
          toastId: customId,
          autoClose : auto_close,
          newestOnTop: true
        });
      }
    //}
  }  

  useEffect(() => {
    if (!socket) return
  
    // message handler
    const handleMessage = (payload) => {
      let data
      try {
        // Depending on server, payload may already be an object or a JSON string
        data = typeof payload === 'string' ? JSON.parse(payload) : payload
      } catch (err) {
        console.error('Invalid message payload', payload, err)
        return
      }

      if(data.event === 'sell_order_sent') {
        notify('Exit order sent to exchange. Order ID: '+data.order_id+' Symbol: '+data.instrument_name, 'success', 'top-right', true); 
      } else if(data.event === 'buy_order_filled') {
          notify('Entry Order Filled. Order ID: '+data.order_id, 'success', 'top-right', true);      
      } else if(data.event === 'buy_order_rejected') {
          notify('Entry Order Rejected. Order ID: '+data.order_id, 'error', 'top-right', true);               
      } else if(data.event === 'buy_order_cancelled') {
          notify('Entry Order Cancelled. Order ID: '+data.order_id, 'error', 'top-right', true);               
      } else if(data.event === 'sell_order_filled') {
          notify('Exit Order Filled. Qty: '+data.qty+' Symbol: '+data.symbol, 'success', 'top-right', true); 
      } else if(data.event === 'sell_order_rejected') {
          notify('Exit Order Rejected. Order ID: '+data.order_id, 'error', 'top-right', true);               
      } else if(data.event === 'sell_order_cancelled') {
          notify('Exit Order Cancelled. Order ID: '+data.order_id, 'error', 'top-right', true);             
      } else if(data.event === 'buy_order_sent') {
          notify('Entry order sent to exchange. Order ID: '+data.order_id+' Qty: '+data.qty+' Symbol: '+data.symbol, 'success', 'top-right', true);           
      }      
  
    }
  
    const handleConnect = () => {
      console.log('Socket connected')
    }
  
    const handleError = (err) => {
      console.log('Socket error', err)
    }
  
    const handleDisconnect = (reason) => {
      console.log('Socket disconnected. Reason:', reason)
    }
  
    // Wire up Socket.IO events
    socket.on('message', handleMessage)      // server should emit 'message', payload
    socket.on('connect', handleConnect)
    socket.on('connect_error', handleError)
    socket.on('disconnect', handleDisconnect)
  
    // Cleanup to avoid duplicate handlers on re-renders
    return () => {
      socket.off('message', handleMessage)
      socket.off('connect', handleConnect)
      socket.off('connect_error', handleError)
      socket.off('disconnect', handleDisconnect)
    }
  }, [socket])


  const terminateAll = () => {
    if (window.confirm("Are you sure you want to terminate all strategy?")) {
      const event_data = {
        event: "stop_all",
        message: "Terminate All Strategy",
      };
      if (socket && socket.connected) {
        socket.emit("client_message", event_data);
      }
    }
  };

  const terminateSquareOffAll = () => {
    if (
      window.confirm(
        "Are you sure you want to squareoff and terminate all strategy?"
      )
    ) {
      const event_data = {
        event: "terminate_all",
        message: "Terminate and SquareOFf All Strategy",
      };
      if (socket && socket.connected) {
        socket.emit("client_message", event_data);
      }
    }
  };

  return (
    <div className="SidebarWrapper">
      <NavbarSection
        ctx={ctx}
        handleOnClick={handleSidebarCollapse}
        sidebarCollapse={sidebarCollapse}
        terminateAll={terminateAll}
        terminateSquareOffAll={terminateSquareOffAll}
        ltpData={ltpData}
        livePnl={livePnl}
        totalPnl={totalPnl}
      />
      <SidebarSection ctx={ctx} sidebarCollapse={sidebarCollapse} />
    </div>
  );
}

export default Sidebar;